
export default class ApiController {

	static get $inject(){
		return [
			'$state',
			'ApiServices'
		];
	}

	constructor($state,
	            ApiServices
	){
		console.log('apiTest.controller');

		let routeFullName = $state.$current.name,
		    routeName = routeFullName.split('.')[routeFullName.split('.').length-1],
		    api = ApiServices.list;



		// Main API object+
		this.currentApi = api[routeName];

		//console.log('routeName:',routeName,this.currentApi);

		// Holds responses for example requests
		this.res = {};

	}

	submit(name, fnc, data, param){
		this.res[name] = null;
		fnc(data, param)
			.then((r)=>{
				this.res[name] = { data: r.data, status: r.status };
			})
			.catch((r)=>{
				this.res[name] = { data: r.data, status: r.status };
			});
	}

}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/controller.js
 **/